import { create } from 'zustand'

interface IPopupStore {
  isOpenFreeGamePopup: boolean
  isOpenFreeGameConfirmPopup: boolean
  isopenMenu: boolean
}

export const usePopupStore = create<IPopupStore>(() => ({
  isOpenFreeGamePopup: false,
  isOpenFreeGameConfirmPopup: false,
  isopenMenu: false,
}))
